import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { optimiseImage } from 'src/common/utils/prismic-image';
import './LineItemImage.scss';

const LineItemImage = props => (
  <div className="line-item-ii-image-wrapper" key="line-item-image-wrapper">
    {!props.addons
      ? null
      : props.addons.map(addon => (
        <img
          key={`addon-image-${addon.id}`}
          src={optimiseImage(addon.image.url, {
            auto: 'format,compress',
            w: get(addon, 'image.dimensions.width', 0),
          })}
          alt={addon.image.alt || ''}
          className="line-item-image line-item-image-ii-addon"
        />
      ))}
    {!props.image
      ? null
      : <img
        key="default-image"
        src={optimiseImage(props.image.url, {
          auto: 'format,compress',
          w: props.image.dimensions.width,
        })}
        alt={props.image.alt || ''}
        className="line-item-image line-item-image-ii--default"
      />
    }
  </div>
);

LineItemImage.propTypes = {
  image: PropTypes.object,
  addons: PropTypes.array.isRequired,
};

export default LineItemImage;



// WEBPACK FOOTER //
// ./src/client/js/view/components/LineItemII/LineItemImage/LineItemImage.js